module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Create an intermediary supplier","name":"Name","cancel":"Cancel","create":"Create"},"fr":{"title":"Créer un fournisseur intermédiaire","name":"Nom","cancel":"Annuler","create":"Créer"},"de":{"title":"Vermittler-Anbieter erstellen","name":"Name","cancel":"Abbrechen","create":"Erstellen"}}')
  delete Component.options._Ctor
}
